export const SET_TRANSPORT_TYPES = 'setTransportTypes'
export const SET_SPECIAL_NEEDS = 'setSpecialNeeds'
export const SET_TRANSPORT_TYPE_OPTIONS = 'setTransportTypeOptions'
export const SET_SPECIAL_NEED_OPTIONS = 'setSpecialNeedOptions'
export const SET_BOOKING = 'setBooking'
export const SET_CLIENT = 'setClient'
export const SET_EDIT_CLINIC_DETAILS = 'setEditClinicDetails'
export const SET_EDIT_CLIENT_DETAILS = 'setEditClientDetails'
export const SET_PROFESSION_OPTIONS = 'setProfessionOptions'
export const SET_SECTION_OPTIONS = 'setSectionOptions'
export const SET_MUNICIPALITY_OPTIONS = 'setMunicipalityOptions'
export const SET_OFFICE = 'setOffice'
export const SET_PREFERENCES = 'setPreferences'
export const SET_TREATMENTSITE_LOADER = 'setTreatmentSiteLoader'
